import { getApi, getKey } from "./getKey";

/**
 * 文本框/多行文本框/上传
 * @param {标签} label
 * @param {输入框的name} postName
 * @param {是否必填} required
 * @param {是否可填} disabled
 * @returns
 */
export const inputObj = (
  label,
  postName,
  required = false,
  disabled = false
) => {
  const getMessage = (label) => {
    switch (label) {
      case "电子邮箱":
        return "电子邮件 如：xxx@163.com";
      case "固定电话":
        return "区号-号码 如：8888-88888888";
      case "其他联系方式":
        return "其他联系方式，如qq、微信等";
      case "其他事项":
        return "请输入其他需要说明的事项";
      case "户口簿首页":
      case "户口簿内申请人本人的页面":
      case "其它相关佐证材料（多附件）":
      case "审核资料":
        return `请上传材料`;
      case "营业执照":
        return `请上传${label}`;
      case "补贴对象类型":
        return "未检测到补贴对象类型"
      default:
        return `请输入${label}`;
    }
  };
  const getInfoType = (label) => {
    switch (label) {
      case "户口簿首页":
      case "户口簿内申请人本人的页面":
      case "其它相关佐证材料（多附件）":
      case "营业执照":
      case "审核资料":
        return "upload";
      case "岗位描述":
      case "其他事项":
      case "自我介绍":
      case "补贴对象类型":
        return "textarea";
      default:
        return "input";
    }
  };

  return {
    infoType: getInfoType(label),
    label: label,
    postName: postName,
    message: getMessage(label),
    required: required,
    disabled: disabled,
  };
};

/**
 * 单项选择/多项选择
 * @param {标签} label
 * @param {输入框的name} postName
 * @param {是否必填} required
 * @param {是否可填} disabled
 * @returns
 */
export const pickerObj = (
  label,
  postName,
  required = false,
  disabled = false,
  defaultValue = ''
) => {
  const getInfoType = (label) => {
    switch (label) {
      case "常住地址":
      case "户籍地址":
      case "工作地点行政区划":
      case '所属地区行政区划代码':
        return "nationPicker";
      case "职业(工种)资格":
      case "职称":
      case "专业技术职务":
      case "意向岗位":
      case "求职意向地":
        return "cascader";
      default:
        return "picker";
    }
  };

  return {
    infoType: getInfoType(label),
    api: getApi(getKey(label)),
    key: getKey(label),
    pickerTitle: `选择${label}`,
    postName: postName,
    label: label,
    message: `请选择${label}`,
    required: required,
    disabled: disabled,
    placeholder: "请选择",
    chooseNum: (label === "户籍地址" || label ===  "常住地址") ? 5 : "",
    defaultValue: defaultValue
  };
};

/**
 * 选择日期
 * @param {标签} label
 * @param {输入框的name} postName
 * @param {是否必填} required
 * @param {是否可填} disabled
 * @returns
 */
export const datePickerObj = (
  label,
  postName,
  required = false,
  disabled = false
) => {
  const other = (label) => {
    switch (label) {
      case "毕业年月":
        return { precision: "month" };
      case "失业时间":
        return { help: "单位与个人解除劳动关系的时间", before: true };
      case "出生日期":
      case "工作时间起":
      case "工作时间止":
      case "在校时间起":
      case "在校时间":
      case "就业日期":
        return { before: true };
      case "申报年度":
        return { precision: "year" };
      default:
        return {};
    }
  };
  return {
    infoType: "datePicker",
    pickerTitle: "选择时间",
    postName: postName,
    label: label,
    required: required,
    disabled: disabled,
    placeholder: "请选择",
    ...other(label),
  };
};

/**
 * 没有数据字典的单项选择
 * @param {标签} label
 * @param {输入框的name} postName
 * @param {是否必填} required
 * @param {是否可填} disabled
 * @returns
 */
export const chooseObj = (
  label,
  postName,
  required = false,
  disabled = false
) => {
  return {
    infoType: "choose",
    pickerTitle: `请选择${label}`,
    postName: postName,
    label: label,
    option: [
      [
        { label: "是", value: 1 },
        { label: "否", value: 2 },
      ],
    ],
    required: required,
    disabled: disabled,
    placeholder: "请选择",
  };
};

/**个人承诺 */
// export const checkBox = (label) => {
//   return {
//     infoType: "checkBox",
//     label: label,
//   };
// };
